import gql from 'graphql-tag'

export const QUERY_DYNAMIC_ATTRIBUTES = gql`
  query DynamicAttributes {
    dynamicAttributes(page: 1, pageSize: 1000) {
      records
      page
      dynamicAttributes {
        _id
        attribute
        type
        origin
        label
        options {
          label
          value
        }
        last_updated_at
      }
    }
  }
`
